export const ArrowTopIcon = () => {
    return (
        <svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.75 0.575161C1.75 0.575161 5.21917 0.303796 5.7077 0.792316C6.19623 1.28084 5.92482 4.75 5.92482 4.75M5.5 1L0.500001 6" stroke="#465F88" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};
